var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signin_logo" }, [
    _c("div", { staticClass: "logo" }, [
      _vm.headerLogo && _vm.headerLogo.length > 0
        ? _c("img", {
            staticClass: "top-logo",
            attrs: { src: _vm._f("imgFormat")(_vm.headerLogo), alt: "" },
          })
        : _c("div", { staticClass: "top-logo" }),
    ]),
    _c("div", { staticClass: "schedule" }, [
      _c("div", { staticClass: "schedule_time" }, [
        _vm._v(_vm._s(_vm.timeString)),
      ]),
      _c("div", { staticClass: "schedule_date" }, [
        _vm._v(_vm._s(_vm.dateString)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }